var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#2B63D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5H11V6H12V5zM14 8H13V9H14V8zM11 10H12V11H11V10zM8 9H7V10H8V9zM9 14H10V15H9V14zM6 12H4V14H6V12zM.0661621 6.96702L2.50008 5.75006V8.00006H5.50008V5.75006L8.00008 7.00006V1.00006L5.50008 2.25006V.398438C4.36731.77076 3.34622 1.38922 2.50008 2.19056V2.25006L2.45915 2.22959C1.17745 3.46062.304991 5.11456.0661621 6.96702z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.155518 6.42217L2.4998 5.25003H1.4998L0.290927 5.85446C0.23911 6.04104 0.193884 6.23037 0.155518 6.42217Z",
    fill: "#E62048"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.687671 4.75003H2.99995V8.00003H4.99995V4.75003H7.99995V3.25003H4.99995V0.581543C4.27429 0.875285 3.60153 1.27241 2.99995 1.75465V3.25003H1.56211C1.21909 3.71416 0.925064 4.21671 0.687671 4.75003Z",
    fill: "#E62048"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 2.00003L6.49996 2.75003H5.49995L7.99996 1.50003V2.00003zM7.99995 6.00002L6.49996 5.25003H7.49996L7.99995 5.50002V6.00002z",
    fill: "#E62048"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8C15.75 12.2802 12.2802 15.75 8 15.75C3.71979 15.75 0.25 12.2802 0.25 8C0.25 3.71979 3.71979 0.25 8 0.25C12.2802 0.25 15.75 3.71979 15.75 8Z",
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })));
}

export default SvgAu;